import apiCallTemplate from './config'
import credentials from '../assets/credentials'

const {BASE_URL}=credentials
const transactionsURL = `${BASE_URL}/transactions`;

//Get all transactions [include params for filtered fetching]
export const allTransactions=async (query)=>apiCallTemplate("get", `${transactionsURL}${query}`)

//Get all user transactions
export const allUserTransactions=async (query)=>apiCallTemplate("get", `${transactionsURL}/my-transactions-history${query || ""}`)

//Get all site revenue
export const getRevenue=async (query)=>apiCallTemplate("get", `${transactionsURL}/total`)

//Get all user revenue
export const getUserRevenue=async (query)=>apiCallTemplate("get", `${transactionsURL}/user/revenue${query? "?"+query:"" }`)

//Get all transactions statistics
export const getTransactionsStats=async (query)=>apiCallTemplate("get", `${transactionsURL}/stats`)

